import { apiConfig } from '../config';
import { getFetch } from '../fetch';

export function getArchivedClasses() {
    const { apiGetArchivedClasses } = apiConfig.getStaticUrls();

    return getFetch(apiGetArchivedClasses);
}
